<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const { getNuxtLink, isExternal } = useCustomLink()
defineProps({
  pickupList: {
    type: Array,
    default: () => []
  },
  pickupTitle: {
    type: String,
    default: () => '服装予報'
  }
})
</script>

<template>
  <section
    v-if="pickupList.length > 0"
    class="clothesData"
  >
    <SectionTitle :title="pickupTitle" />
    <div class="content">
      <!-- ２列分 -->
      <div
        v-for="i in 2"
        :key="i"
        class="item head"
      >
        <div class="name" />
        <figure class="clothes day">
          <span>昼間</span>
          <img
            src="https://gvs.weathernews.jp/clothes/images/icon/icon_day.svg"
            width="13"
            height="14"
            loading="lazy"
            alt=""
          >
        </figure>
        <figure class="clothes night">
          <span>朝晩</span>
          <img
            src="https://gvs.weathernews.jp/clothes/images/icon/icon_night.svg"
            width="24"
            height="12"
            loading="lazy"
            alt=""
          >
        </figure>
      </div>
      <div
        v-for="item in pickupList"
        :key="item.roma"
        class="item"
      >
        <NuxtLink
          :to="getNuxtLink(item.link)"
          :external="isExternal(item.link)"
          class="link"
        >
          {{ item.name }}
        </NuxtLink>
        <figure
          class="clothes"
          :data-tooltip="item?.daytime?.name"
        >
          <img
            :src="item?.daytime?.icon"
            width="30"
            height="25"
            loading="lazy"
          >
        </figure>
        <figure
          class="clothes"
          :data-tooltip="item?.asaban?.name"
        >
          <img
            :src="item?.asaban?.icon"
            width="30"
            height="25"
            loading="lazy"
          >
        </figure>
      </div>
    </div>
  </section>
</template>

  <style lang="scss" scoped>
  .clothesData {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .content {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 12px;
    }
    .item {
      display: flex;
    }
    .name {
      flex: 1;
      background-color: #F5F5F5;
      border-left: solid 1px #F5F5F5;
      border-right: solid 1px #fff;
      border-bottom: solid 1px #F5F5F5;
    }
    .link {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      flex: 1;
      color: #3569C0;
      font-size: 15px;
      font-weight: 500;
      line-height: 1em;
      text-decoration: underline;
      border-left: solid 1px #F5F5F5;
      border-right: solid 1px #F5F5F5;
      border-bottom: solid 1px #F5F5F5;
    }
    .clothes {
      display: flex;
      align-items: center;
      gap: 5px;
      width: 45px;
    padding: 4px;
      border-right: solid 1px #F5F5F5;
      border-bottom: solid 1px #F5F5F5;
      &:is(.head *) {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 18px;
      padding: 3px 2px;
        img {
          width: auto;
          height: 100%;
        }
      }
      span {
        display: block;
        color: #303030;
        font-size: 10px;
        font-weight: 500;
        line-height: 1em;
      }
      img {
        width: 100%;
        height: auto;
        object-fit: contain;
      }
      &.day {
        background-color: #F7F7E9;
        border-right-color: #fff;
      }
      &.night {
        background-color: #EEF1F8;
      }
  }
  .legend {
    margin-left: auto;
    padding-left: 20px;
    background-image: url("https://gvs.weathernews.jp/clothes/images/icon/icon_legend.svg");
    background-position: left center;
    background-repeat: no-repeat;
    background-size: 15px;
    color: #3569c0;
    line-height: 1em;
    text-decoration: underline;
    }
    @media (any-hover: hover) {
      .link {
        transition: color .2s ease-in-out;
        &:hover {
          color: rgb(53 105 192 / .6);
        }
      }
      .clothes {
        position: relative;
        &[data-tooltip] {
          padding-inline: 12px;
          &::after {
            position: absolute;
            bottom: 105%;
            left: 0;
            display: block;
            padding: 7px 8px 5px;
            background: #000;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 300;
            color: #fff;
            white-space: nowrap;
            content: attr(data-tooltip);
            opacity: 0;
            z-index: 10;
            transition: opacity .2s ease-in-out;
            pointer-events: none;
          }
        }
        &:hover {
          &::after {
            opacity: 1;
          }
        }
      }
      .item {
        &:nth-child(2n) {
          .clothes {
            &[data-tooltip] {
              &::after {
                left: auto;
                right: 0;
              }
            }
          }
        }
      }
      .legend {
        cursor: pointer;
        transition: opacity .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
    }
  }
  .main {
    .clothesData {
      @media screen and (min-width: 830px) {
        .clothes {
        width: 75px;
        &:is(.head *) {
          height: 25px;
          padding-block: 3px;
        }
        span {
          font-size: 12px;
        }
      }
      }
    }
  }
  </style>
